angular.module('auth')
  .service('NotificationPlant',function($resource,$http,BASE_PATH){
    return $resource(BASE_PATH.API_URL + 'groups/:group_id/notificationPlants/:plant_id', {
      group_id: '@group_id',
      plant_id: '@plant_id'
    });
  });
